export const ENV_CONFIG = {
  MODE: 'PRODUCTION',
  CLOUD_STORAGE: {
    URL: 'https://storage.googleapis.com/oath_1',
  },
};
